/* eslint-disable import/prefer-default-export */
import React from 'react';
import styled from 'react-emotion';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Wrapper = styled((props) => <FormControlLabel {...props} />)`
  span {
    color: ${colors.blackAlpha(0.87)};
    font-family: ${theme.font.family.workSans};
    font-weight: ${theme.font.weight.regular};
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
    white-space: pre-wrap;
  }

  span:last-child {
    padding-left: ${theme.spacing.small};
  }

  span > svg {
    color: ${colors.blackAlpha(0.6)};
  }
`;
